module.exports = __webpack_public_path__ + "img/frame5.fdeedfe7.jpg";